module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fAD4V"))).then(() => parcelRequire('2KbAe'));